import { Url } from "../../general/modules/url";
import { MailingLoginQueryParams } from "./MailingLoginQueryParams";
import { GlobalAppConfig } from "../../types/windowPatching";

export class MailingUser {
    private readonly deviceId: string;
    private readonly mailingToken: string;
    private readonly suid: string;
    private readonly entryPoint: string;
    private readonly locale: string;
    private readonly generatedAt: string;
    private readonly groupBy: string;
    public readonly isProviderAction: boolean;

    constructor(deviceId: string, config: GlobalAppConfig, url: Url) {
        this.deviceId = deviceId;
        this.locale = config.locale;
        this.entryPoint = config.current_entry_point;
        this.mailingToken = url.getQueryParam(MailingLoginQueryParams.TOKEN);
        this.suid = url.getQueryParam(MailingLoginQueryParams.SUID);
        this.generatedAt = url.getQueryParam(MailingLoginQueryParams.GENERATED_AT);
        this.groupBy = url.getQueryParam(MailingLoginQueryParams.GROUP_BY);
        this.isProviderAction = !!url.getQueryParam(MailingLoginQueryParams.PROVIDER_ACTION);
    }

    public getGeneratedAt(): string {
        return this.generatedAt;
    }

    public getDeviceId(): string {
        return this.deviceId;
    }

    public getEntryPoint(): string {
        return this.entryPoint;
    }

    public getLocale(): string {
        return this.locale;
    }

    public getMailingToken(): string {
        return this.mailingToken;
    }

    public getSuid(): string {
        return this.suid;
    }

    public getGroupBy(): string {
        return this.groupBy;
    }

    public hasToBeAuthByToken(): boolean {
        return this.isProviderAction;
    }
}
